import { IBasePostInfo } from "./models";

const hasMoreThanOnePost = (selectedPosts: IBasePostInfo[]): boolean => selectedPosts && selectedPosts.length > 1;

export const getDigitalScreensTitle = (selectedPosts: IBasePostInfo[]): string => `Export as Slide${hasMoreThanOnePost(selectedPosts) ? "s" : ""}`;

export const getDigitalScreensButtonText = (selectedPosts: IBasePostInfo[], maxAmount: number): string => `${getDigitalScreensTitle(selectedPosts)} ${hasMoreThanOnePost(selectedPosts) ? `(max. ${maxAmount})` : ""}`